import React from 'react';
import { useStyletron } from 'baseui';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from './formConfig';
import { ContentPropsT } from './constants';
import useContent from './useContent';

const Content = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useContent({
		handleFilterSubmit,
		onClose
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
